module.exports = __webpack_public_path__ + "static/media/nav-appointments-active.cef35649.svg";